import { Check } from "lucide-react";
import { Eyebrow, Item, Reveal, Stagger } from "../components/Reveal";

const BENEFITS = [
  "Mais agilidade",
  "Mais controle",
  "Mais transparência",
  "Menos retrabalho",
  "Comunicação organizada",
  "Histórico das demandas",
  "Profissionais qualificados",
  "Acompanhamento de ponta a ponta",
];

export const Benefits = () => (
  <section className="relative py-24 lg:py-32" data-testid="benefits-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow>Benefícios</Eyebrow>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-petrol sm:text-3xl lg:text-4xl">
          Menos preocupação. <span className="text-brand">Mais solução.</span>
        </h2>
      </Reveal>

      <Stagger className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {BENEFITS.map((b) => (
          <Item key={b} data-testid={`benefit-${b.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="group flex h-full items-center gap-4 rounded-2xl border border-slate-200/80 bg-white p-5 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-brand/40 hover:shadow-[0_20px_40px_-18px_rgba(0,102,255,0.25)]">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand/10 text-brand transition-colors duration-300 group-hover:bg-brand group-hover:text-white">
                <Check className="h-4 w-4" strokeWidth={3} />
              </span>
              <span className="text-sm font-semibold text-petrol">{b}</span>
            </div>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);
